import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

const ERRORS = `errors { path, message }`;

const TITLE_LOG_FIELDS = `
  id
  asset {
    id
    year
    make
    model
    vin
    name
    seller {id, name}
    status
    buyer { id, name, street, city, state, email, postalCode { formatted } }
    soldOn
    titleReleaseWarning
  }
  status
  upload { id, filename, contentType, url}
  linkedAttachment { id, name, url, resourceId, resourceType }
  titleNumber
  state
  trackingShipper
  trackingNumber
  notes
  createdAt
`;

const TITLE_LOG_VARIABLES = `
  $assetId: ID!
  $status: String!
  $upload: Upload
  $linkedAttachment: LinkedAttachmentInput
  $titleNumber: String
  $state: String
  $trackingShipper: String
  $trackingNumber: String
  $sendTrackingEmail: Boolean
  $notes: String
`;

const TITLE_LOG_ARGUMENTS = `
  assetId: $assetId
  status: $status
  upload: $upload
  linkedAttachment: $linkedAttachment
  titleNumber: $titleNumber
  state: $state
  trackingShipper: $trackingShipper
  trackingNumber: $trackingNumber
  sendTrackingEmail: $sendTrackingEmail
  notes: $notes
`;

const EDIT_TITLE_LOG_VARIABLES = `
  $status: String!
  $titleNumber: String
  $state: String
  $trackingShipper: String
  $trackingNumber: String
  $sendTrackingEmail: Boolean
  $notes: String
  $linkedAttachmentAttributes: LinkedAttachmentInput
`;

const EDIT_TITLE_LOG_ARGUMENTS = `
  status: $status
  titleNumber: $titleNumber
  state: $state
  trackingShipper: $trackingShipper
  trackingNumber: $trackingNumber
  sendTrackingEmail: $sendTrackingEmail
  notes: $notes
  linkedAttachmentAttributes: $linkedAttachmentAttributes
`;

const TITLE_LOG_FIELDS_AND_ERRORS = `
  titleLog {
    ${TITLE_LOG_FIELDS}
  }
  ${ERRORS}
`;

export const TITLE_LOGS_WITH_COUNT = gql`
  query (
    $assetId: ID
    ${WITH_COUNT_VARIABLES}
  ) {
    titleLogsWithCount(
      assetId: $assetId
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${TITLE_LOG_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_TITLE_LOG = gql`
  mutation CreateTitleLog(
    ${TITLE_LOG_VARIABLES}
  ) {
    createTitleLog(
      ${TITLE_LOG_ARGUMENTS}
    ) {
      ${TITLE_LOG_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_TITLE_LOG = gql`
  mutation UpdateTitleLog(
    $id: ID!
    ${EDIT_TITLE_LOG_VARIABLES}
  ) {
    updateTitleLog(
      id: $id
      ${EDIT_TITLE_LOG_ARGUMENTS}
    ) {
      ${TITLE_LOG_FIELDS_AND_ERRORS}
    }
  }
`;

export const TITLE_LOG = gql`
  query TITLE($id: ID!) {
    titleLog(id: $id) {
      ${TITLE_LOG_FIELDS}
    }
  }
`;

export const HIDE_TITLE_LOG = gql`
  mutation HideTitleLog($id: ID!) {
    hideTitleLog(id: $id) {
      titleLog {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;
